import React from "react";
import { relativeShort, type Signal, type SignalSeverity } from "../../utils/operationsDashboard";

// An 8px dot carries severity at a glance, and eai-danger stays reserved for the genuinely bad — four colours compete
const DOT: Record<SignalSeverity, string> = {
  negative: "bg-eai-danger",
  attention: "bg-eai-cta-primary",
  positive: "bg-eai-cta-primary",
  neutral: "bg-eai-ink-ghost",
};

// Severity as the row's ground, reusing the tints the Failing pill already carries so nothing new enters the palette
const TINT: Record<SignalSeverity, string> = {
  negative: "bg-eai-danger-soft",
  attention: "bg-eai-checklist-lt",
  positive: "bg-eai-checklist-lt",
  neutral: "bg-eai-surface-hover",
};

interface SignalRowProps {
  signal: Signal;
}

// Read-only: Alerts states the fault rather than linking out, so the row has no hover and no destination
const SignalRow: React.FC<SignalRowProps> = ({ signal }) => (
  <div className={`flex items-start gap-3 rounded-md px-2 py-2 ${TINT[signal.severity]}`}>
    <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${DOT[signal.severity]}`} aria-hidden="true" />
    <span className="min-w-0 flex-1">
      <span
        className={`block font-inter text-eai-body-sm ${
          signal.severity === "negative" ? "font-medium text-eai-ink" : "font-medium text-eai-ink-soft"
        }`}
      >
        {signal.title}
      </span>
      {/* The meta line owns the age, as on every other card — level with the title it would steal the width that made it wrap */}
      <span className="mt-0.5 flex items-baseline justify-between gap-2 font-inter text-eai-body-xs text-eai-ink-faint">
        <span className="truncate">{signal.count ? `${signal.count}×` : ""}</span>
        <span className="shrink-0">
          {relativeShort(new Date(signal.at).getTime(), Date.now())}
        </span>
      </span>
    </span>
  </div>
);

export default SignalRow;
